var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"number-line-section tw-flex tw-items-center tw-justify-center tw-px-1 tw-text-center",style:({
    backgroundColor: _vm.backgroundImage ? null : _vm.color,
    flexBasis: _vm.displayWidth || 0,
    flexGrow: _vm.displayWidth ? null : 1,
    borderRight: _vm.isLast ? null : '1px solid rgba(0,0,0,0.3)',
  })},[_c('div',{},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }